import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ComponentsModule } from '../../components/components.module';
import { HomeComponent } from './home.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { BnNgIdleService } from 'bn-ng-idle';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFaviconService } from 'angular-favicon';

const routes: Routes = [
  {
    path: '', component: HomeComponent, canActivate: [AuthGuard], children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      { path: 'threshold-config',
        loadChildren: () => import('../threshold-config/threshold-config.module').then(m => m.ThresholdConfigModule)
      },
      {
        path: 'goal',
        loadChildren: () => import('../goal/goal-config.module').then(m => m.GoalConfigModule)
      },
      {
        path: 'sport', loadChildren: '../sports/sports.module#SportsModule'
      },
      { path: 'clients', loadChildren: '../manage-clients/manage-clients.module#ManageClientsModule' },
      { path: 'exclusions', loadChildren: '../manage-exclusions/manage-exclusions.module#ManageExclusionsModule' },
      { path: 'limits', loadChildren: '../manage-limits/manage-limits.module#ManageLimitsModule' },
      { path: 'bet-settings', loadChildren: '../bet-settings/bet-settings.module#BetSettingsModule' },
      { path: 'bonus-settings', loadChildren: '../bonus-settings/bonus-settings.module#BonusSettingsModule' },
      { path: 'freebet-assignment', loadChildren: '../freebet-assignment/freebet-assignment.module#FreebetAssignmentModule' },
      { path: 'channel', loadChildren: '../channels/channels.module#ChannelsModule'},
      { path: 'publicity', loadChildren: '../publicity/publicity.module#PublicityModule' },
      { path: 'client/:id', loadChildren: '../client-detail/client-detail.module#ClientDetailModule' },
      { path: 'categories', loadChildren: '../categories/categories.module#CategoriesModule' },
      { path: 'tournament', loadChildren: '../tournaments/tournaments.module#TournamentsModule' },
      { path: 'event', loadChildren: '../events/events.module#EventsModule' },
      { path:  'event/:id', loadChildren: '../event-detail/event-detail.module#EventDetailModule' },
      { path: 'event-restriction', loadChildren: '../event-restriction/event-restriction.module#EventRestrictionModule' },
      { path:  'channel/:id', loadChildren: '../channel-detail/channel-detail.module#ChannelDetailModule' },
      { path:  'market', loadChildren: '../market/market.module#MarketModule' },
      { path:  'results', loadChildren: '../results/results.module#ResultsModule' },
      { path:  'group', loadChildren: '../group/group.module#GroupModule' },
      { path:  'manual-odds', loadChildren: '../manual-market/manual-market.module#ManualMarketModule' },
      { path:  'tax-configuration', loadChildren: '../tax-configuration/tax-configurations.module#TaxConfigurationModule' },
      { path:  'tax-payment', loadChildren: '../tax-payment/tax-payment.module#TaxPaymentModule' },
      { path:  'package-config', loadChildren: '../package-config/package-config.module#PackageConfigModule' },
      { path: 'games', loadChildren: '../game-lists/game-lists.module#GameListsModule'},
      { path: 'text-slidders', loadChildren: '../text-slidders/text-slidders.module#TextSliddersModule'},
      { path: 'tickets', loadChildren: '../tickets/tickets.module#TicketsModule'},
      { path: 'tickets/:id', loadChildren: '../tickets/tickets.module#TicketsModule'},

      {path: 'dashboard-config', loadChildren:
            () => import('../dashboard-config/dashboard-config.module').then(mod => mod.DashboardConfigModule)
      },
      {path: 'providers', loadChildren: '../providers/providers.module#ProvidersModule'},
      { path: 'notification', loadChildren: '../notification-settings/notifications.module#NotificationsModule'},
      { path: 'risk-config',  loadChildren: '../risk-configurations/risk-configurations.module#RiskConfigurationsModule'},
      { path: 'black-list',  loadChildren: '../phone-numbers/phone-numbers.module#PhoneNumbersModule'},
      { path: 'payments',  loadChildren: '../payments/payments.module#PaymentsModule'},
      { path: 'suspended-payment',  loadChildren: '../suspended-tickets/suspended-tickets.module#SuspendedTicketsModule'},
      { path: 'partners',  loadChildren: '../partners/partners.module#PartnersModule'},
      { path: 'partner/:id',  loadChildren: '../partner-detail/partner-detail.module#PartnerDetailModule'},
      { path: 'products',  loadChildren: '../products/products.module#ProductsModule'},
      { path: 'cashout-settings',  loadChildren: '../cashout-settings/cashout-settings.module#CashoutSettingsModule'},
      { path: 'nav', loadChildren: '../nav/nav.module#NavModule'},
      { path: 'nav/:id', loadChildren: '../nav/nav.module#NavModule'},
      { path: 'footer', loadChildren: '../footer-content/footer-content.module#FooterContentModule'},
      { path: 'footer/:id', loadChildren: '../footer-content/footer-content.module#FooterContentModule'},
      { path: 'product-type',  loadChildren: '../product-type/product-type.module#ProductTypeModule'},
      { path: 'avis-expert',  loadChildren: '../avis-expert/avis-expert.module#AvisExpertModule'},
      { path: 'promotions',  loadChildren: '../promotions/promotions.module#PromotionsModule'},
      { path: 'speciale-cagnotte',  loadChildren: '../speciale-cagnotte/speciale-cagnotte.module#SpecialeCagnotteModule'},
      { path: 'PRS',  loadChildren: '../partner-revenue-share/partner-revenue-share.module#PartnerRevenueShareModule'},
      // { path: 'PRS/:id',  loadChildren: '../partner-revenue-share/partner-revenue-share-details/partner-revenue-share-details.module#PartnerRevenueShareDetailsModule'},
      { path: 'sport-promotions',  loadChildren: '../sport-promotions/sport-promotions.module#SportPromotionsModule'},
      { path: 'demo-accounts',  loadChildren: '../demo-accounts-management/demo-accounts-management.module#DemoAccountsManagementModule'}
      // { path: 'login',  loadChildren: '../login/login.module#LoginModule'}
      // { path: 'products/:id',  loadChildren: '../product-detail/product-detail.module#ProductDetailModule'},

    ]
  }
];

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes)
  ],
  providers: [BnNgIdleService,AngularFaviconService]
})
export class HomeModule { }
